/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Url_Must_Include_DomainInputs */

const en_common_url_must_include_domain = /** @type {(inputs: Common_Url_Must_Include_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website URL must include a domain (e.g., example.com)`)
};

const es_common_url_must_include_domain = /** @type {(inputs: Common_Url_Must_Include_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La URL del sitio debe incluir un dominio (ej., example.com)`)
};

/**
* | output |
* | --- |
* | "Website URL must include a domain (e.g., example.com)" |
*
* @param {Common_Url_Must_Include_DomainInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_url_must_include_domain = /** @type {((inputs?: Common_Url_Must_Include_DomainInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Url_Must_Include_DomainInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_url_must_include_domain(inputs)
	return en_common_url_must_include_domain(inputs)
});